export function getConfig(cfg) {
  const num = (v, d) => { const n = Number(v); return Number.isFinite(n) ? n : d; };
  return {
    establishedYear: num(cfg?.establishedYear, 1999),
    learnerBaseline: num(cfg?.learnerBaseline, 18000),
    learnerPerYear: num(cfg?.learnerPerYear, 500),
    baseYear: num(cfg?.baseYear, 2026),
    iso: cfg?.iso ?? "ISO 21001:2018 Certified",
  };
}

export function yearsSince(cfg) {
  const c = getConfig(cfg);
  return Math.max(1, new Date().getFullYear() - c.establishedYear);
}

export function learnerCount(cfg) {
  const c = getConfig(cfg);
  const y = new Date().getFullYear();
  const n = c.learnerBaseline + Math.max(0, y - c.baseYear) * c.learnerPerYear;
  return Math.round(n / 500) * 500;
}
